import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import FormEdit from '../../../../components/auth/projetocultural/listar/form_edit'
import Head from '../../../../components/head'


function EditarDProjetoCulturalScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Projeto Cultural" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarDProjetoCulturalScreen;